import script from "./editSpecial.vue?vue&type=script&setup=true&lang=js"
export * from "./editSpecial.vue?vue&type=script&setup=true&lang=js"

import "./editSpecial.vue?vue&type=style&index=0&id=3fdc034e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdc034e"]])

export default __exports__